import { axiosInstance } from '~/services';

import type {
  TypeApiResponse,
  TypeGetInboundAreaOperationTimesParams,
  TypeGetInboundAreaOperationTimesResponse,
} from '~/types/receive.types';

/**
 * [입고요청관리] 입고(예약)가능 시간대 목록 조회 API
 */
export const fetchInboundAreaOperationTimes = async (
  params: TypeGetInboundAreaOperationTimesParams
): Promise<TypeGetInboundAreaOperationTimesResponse> => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetInboundAreaOperationTimesResponse>>(
    '/api-inbound/v1/3pl/inbound-area/operation-times',
    { params }
  );
  return data.data;
};
